import { LayoutGrid, UtensilsCrossed, Star, Sparkles, ChefHat, Soup } from "lucide-react";

export const ALL_ITEMS_ICONS = { LayoutGrid, UtensilsCrossed, Star, Sparkles, ChefHat, Soup };

/** Icon chosen in POS Menu → Categories → All Items Appearance (falls back to LayoutGrid). */
export function AllItemsIcon({ appearance, size = 16, ...rest }) {
  const Icon = ALL_ITEMS_ICONS[appearance?.icon] || LayoutGrid;
  return <Icon size={size} style={{ color: appearance?.color || "#0f172a" }} {...rest} />;
}
